/*
 *  -----------------------------------------------------------------------
 *    <copyright file="select-import-file/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogContent } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'hooks';
import Button from 'views/components/core/buttons';
import { CustomDialog, DialogActions, DialogTitle } from 'views/components/core/dialog';
import FileUploader from 'views/components/core/file-uploader';
import './styles.scss';

const SelectImportFile = ({ open, onClose }: { open: boolean; onClose: Function }) => {
    const { t } = useTranslation();

    const [fileError, setFileError] = useState(null);
    const [file, setFile] = useState(null);

    useEffect(() => {
        if (!open) {
            setFileError(null);
            setFile(null);
        }
    }, [open]);

    const close = (config?: any) => {
        onClose(config);
    };

    const onFileUpload = (newFile: any) => {
        setFile(newFile);
        if (newFile) onClose(newFile);
    };

    const importFile = () => {
        if (!file) setFileError(t('admin:invalidJsonFile'));
    };

    return (
        <CustomDialog
            onClose={() => {
                close();
            }}
            fullWidth
            maxWidth="md"
            scroll="paper"
            open={open}
        >
            <DialogTitle id="inport-study-modal-title">
                {`${t('admin:selectImportFile')}`}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={() => {
                        close();
                    }}
                    data-testid="close-dialog"
                />
            </DialogTitle>
            <DialogContent className="add-treatment-dialog-content">
                <div className="import-file-text">{`${t('admin:selectValidJSON')}`}</div>
                <div className="file-uploader-wrapper">
                    <FileUploader
                        acceptedFileTypes={{
                            'application/octet-stream': ['.opra'],
                        }}
                        onFileUpload={onFileUpload}
                        error={fileError}
                        onError={setFileError}
                    />
                </div>
                <DialogActions className="add-treatment-dialog-content-actions flex-end">
                    <Button id="import-file-study-btn" text="Next" onClick={importFile} disabled={!!fileError} />
                </DialogActions>
            </DialogContent>
        </CustomDialog>
    );
};

export default SelectImportFile;
